import { normalizeSportValue } from '../constants/sports'

// Los deportes que juega un jugador. Fuente de verdad: la INSCRIPCION (spec §8.1).
//
// Retira el cache `jugadores_meta.meta_key='deportes'`, que era una copia de los
// grupos recalculada por la Edge Function recalculate-player-metadata -- invocada
// SIN revisar el error, asi que podia quedar vieja en silencio y nadie enterarse.
//
// El grupo VIVO entra como complemento, no como respaldo del cache: el candado
// suave (F2) NO aplica a deportes sin temporada abierta (no habria donde
// inscribir), asi que un jugador puede estar legitimamente en un grupo de tackle
// sin inscripcion de tackle. Sin el complemento, ese niño se quedaria sin
// deporte y Uniformes no sabria que entregarle.
//
// En los deportes CON temporada abierta el complemento no agrega nada: el candado
// garantiza que quien esta en el grupo esta inscrito.
//
// Puro: recibe lo ya consultado.
//   inscripciones: [{ deporte_id, estatus, temporadas: { estado } }]
//   jugadoresGrupos: [{ activo, deleted, grupos: { deporte } }]
export const deportesDeJugador = ({ inscripciones = [], jugadoresGrupos = [] } = {}) => {
  const deInscripcion = (inscripciones || [])
    .filter((i) => i && i.estatus !== 'baja' && i.temporadas?.estado === 'abierta')
    .map((i) => normalizeSportValue(i.deporte_id))

  const deGrupos = (jugadoresGrupos || [])
    .filter((jg) => jg && jg.activo && !jg.deleted && jg.grupos?.deporte)
    .map((jg) => normalizeSportValue(jg.grupos.deporte))

  return [...new Set([...deInscripcion, ...deGrupos])]
}

// Select anidado para traer lo que necesita deportesDeJugador en la misma consulta
// (no una por jugador).
export const DEPORTES_SELECT = `
  temporada_inscripciones!left (
    deporte_id,
    estatus,
    temporadas ( estado )
  )
`
